import { FC, useRef } from 'react';
import base from '../../styles/Base.module.css';
import style from '../../styles/SubscriptionDetail.module.css';

type CategoryAccordionProps = {
  category: { title: string; anker_id: string };
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  isLoading: boolean;
  productCount?: number;
};

export const CategoryAccordion: FC<CategoryAccordionProps> = ({
  category,
  isOpen,
  onToggle,
  children,
  isLoading,
  productCount,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className={style.categoryAccordion} id={category.anker_id}>
      <button
        className={`${style.categoryAccordionHeader} ${isOpen ? style.categoryAccordionHeaderOpen : ''}`}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <h3 className={base.sectionHeading}>
          {category.title}
          {productCount !== undefined && productCount > 0 && (
            <span className={style.categoryProductCount}>({productCount})</span>
          )}
        </h3>
        <span className={`${style.categoryAccordionIcon} ${isOpen ? style.categoryAccordionIconOpen : ''}`}>
          {isOpen ? '−' : '+'}
        </span>
      </button>

      {isOpen && (
        <div ref={contentRef} className={style.categoryAccordionContent}>
          {isLoading ? (
            <div className={style.categoryLoading}>
              <p>商品を読み込み中...</p>
            </div>
          ) : (
            children
          )}
        </div>
      )}
    </div>
  );
};
